import type { ChangeColumnVisibilityModel } from '../../data/change-column-visibility-model';

export class ChangeColumnVisibilityAction {
  static readonly type = '[Table] ChangeColumnVisibility';

  constructor(readonly columnVisibility: ChangeColumnVisibilityModel) {}
}
